<template>
    <b-modal
        v-if="!imagePreview"
        modal-class="image-modal"
        :hide-header="true"
        id="bv-modal-image"
        ref="modal">
      <div class="fill"
           style="width: 600px; height: 600px;"
           :style="'background-image: url(\''+imageSource+'\'); max-width:' + imgW + 'px; max-height:' + imgH +'px;'"></div>
      <img :src="imageSource" alt="Image" class="imgDialog" ref="image">

      <template #modal-footer="{close}" class="p-0">
        <FooterNavbar data-test-path="image-dialog-footer" class="w-100">
          <CloseButton @close="hide"></CloseButton>
          <FooterButton v-if="attachment" type="Edit" @edit="edit"></FooterButton>
          <DownloadButton v-if="!imagePreview" :file-src="imageSource"></DownloadButton>
        </FooterNavbar>
      </template>
    </b-modal>

    <b-modal
        v-else-if="imagePreview && !checkIsCordova"
        modal-class="image-modal"
        :hide-header="true"
        hide-backdrop
        id="bv-modal-image"
        ref="modal"
        size="600"
    >
      <div  class="fill"
            :style="'background-image: url(\''+imageSource+'\'); max-width:' + imgW + 'px; max-height:' + imgH +'px;'"></div>
      <img  :src="imageSource" alt="Image" class="imgDialog" ref="image">

      <template #modal-footer="{close}" class="p-0">
        <FooterNavbar data-test-path="image-dialog-footer" class="w-100">
          <CloseButton @close="hide"></CloseButton>
          <FooterButton v-if="attachment" type="Edit" @edit="edit"></FooterButton>
          <DownloadButton v-if="!imagePreview" :file-src="imageSource"></DownloadButton>
        </FooterNavbar>
      </template>
    </b-modal>

    <b-modal
        v-else-if="imagePreview && checkIsCordova"
        modal-class="image-modal"
        :hide-header="true"
        hide-backdrop
        id="bv-modal-image"
        ref="modal"
        size="600"
    >
      <div  class="fill"
            :style="'background-image: url(\''+$secureUrl(imageSource)+'\'); max-width:' + imgW + 'px; max-height:' + imgH +'px;'"></div>
      <img  :src="$secureUrl(imageSource)" alt="Image" class="imgDialog" ref="image">

      <template #modal-footer="{close}" class="p-0">
        <FooterNavbar data-test-path="image-dialog-footer" class="w-100">
          <CloseButton @close="hide"></CloseButton>
          <FooterButton v-if="attachment" type="Edit" @edit="edit"></FooterButton>
          <DownloadButton v-if="!imagePreview" :file-src="imageSource"></DownloadButton>
        </FooterNavbar>
      </template>
    </b-modal>
</template>
<script>

import FooterNavbar from "@/components/navbar/FooterNavbar";
import ActivityManager from "@/activity/ActivityManager";
import FooterButton from "@/components/navbar/FooterButton";
import DownloadButton from "@/components/navbar/DownloadButton";
import CloseButton from "@/components/navbar/CloseButton";

const PinturaImageEditor = () => require("@/components/img/PinturaImageEditor");

export default {
  name: "ImageDialog",
  components: {DownloadButton, FooterButton, FooterNavbar, CloseButton},
  created() {
  },

  mounted(){
    this.$root.$on('bv::modal::hide', this.hide);
  },
  computed:{
    checkIsCordova(){
      return window.isCordova
    },
    addCordovaUrl(){
      return window.cordovaUrl
    }
  },
  methods: {

    hide(){
      window.removeEventListener("keypress", this.hide);
      this.$refs.modal.hide();
    },


    reset(){
      this.image = null;
    },

    loadSize(){
      this.imgW = this.$refs.image.naturalWidth;
      this.imgH = this.$refs.image.naturalHeight;
    },

    async edit(){
      setTimeout(async () => {

        let pinturaImageEditorResult = await(await ActivityManager.showActivity(PinturaImageEditor, {
          image: this.attachment,
          uploadImage: async () => await Rpc.Users.uploadImage(null)
        })).getResult();
      });
      this.hide();
  },

    setAttachment(attachment){
      this.attachment = attachment;
    },
    setImagePreview(){
      this.imagePreview = true;
    },
    setUrl(src){
      this.imgW = 0;
      this.imgH = 0;
      this.imageSource= src;
      setTimeout(() => {
        this.loadSize();
        window.addEventListener("keypress", this.hide);
        this.$refs.image.onload = () => {
          this.loadSize();
        };
      })
    },

  },

  props: {
  },

  data: () => ({
    attachment: null,
    imgW: 0,
    imgH: 0,
    imageSource: "",
    image: null,
    imagePreview: false,
  })
}
</script>

<style>

.modal .modal-600 {
  max-width: 40vw;
  width: 40vw;
  max-height: 70vh;
  height: 70vh;
}

.image-modal .modal-dialog {
  margin: auto !important;
}

@media only screen and (min-width: 500px) and (max-width: 950px) {
  .modal .modal-600 {
    min-width: 60vw !important;
    max-width: 60vw !important;
    width: 60vw !important;
    max-height: 60vh;
    height: 60vh;
  }
  .image-modal .modal-dialog {
    margin: auto !important;
  }
}


@media only screen and (max-width: 500px) {
  .modal .modal-600 {
    max-width: 300px;
    width: 300px;
    max-height: 400px;
    height: 400px;
  }
  .image-modal .modal-dialog {
    margin: auto !important;
  }
}


</style>